/* eslint-disable */
//Category
import Attributes from "@/views/Attributes.vue";
import attributesIndex from "@/components/attributes/Index.vue";
import attributesAdd from "@/components/attributes/Add.vue";

//Middleware
import isLogin from "@/middleware/AuthMiddleware.js";

export default {
  path: "/attributes",
  component: Attributes,
  children:[
    {
      path:'/',
      name: "attributes",
      component:attributesIndex,
      meta:{
        parent: "attributes",
        title: "Attribute",
        navbar:true,
        middleware:[
          isLogin,
        ]
      },
    },
    {
      path:'add',
      component:attributesAdd,
      name: 'attributes.add',
      meta:{
        parent: "attributes",
        title: "Add Attribute",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    },
    {
      path:'edit/:id',
      component:attributesAdd,
      name:"attributes.edit",
      meta:{
        parent: "attributes",
        title: "Edit Attribute",
        navbar:true,
        middleware:[
          isLogin,
        ]
      }
    }
  ]
}